// Ticket de la venta de accesorios cerrada: folio, total y fecha. Se cierra con «Listo».
import { CheckCircle2 } from 'lucide-react';
import { Button, CopyableId, Modal } from '@/kit';
import { formatDateMx, formatTimeMx } from '@/lib/dateHelpers';
import { formatMoneyCents } from '@/shared/lib/format/money';
import type { AccessorySale } from '@/api/services/retail-wizard/accessorySales.client';

export function AccessorySaleReceiptModal({
    sale,
    onClose,
}: {
    sale: AccessorySale | null;
    onClose: () => void;
}) {
    return (
        <Modal isOpen={sale !== null} onClose={onClose} title="Venta completada" size="sm">
            {sale && (
                <div className="flex min-w-0 flex-col items-center gap-3 text-center">
                    <CheckCircle2 className="size-10 text-success" aria-hidden />
                    <CopyableId
                        label="Folio"
                        value={sale.folio}
                        className="w-full items-center"
                        wrap
                    />
                    <div>
                        <div className="text-[10px] font-bold uppercase tracking-[0.06em] text-muted-foreground">
                            Total cobrado
                        </div>
                        <div className="text-[20px] font-bold tabular-nums">
                            {formatMoneyCents(sale.amountCents)}
                        </div>
                    </div>
                    <div className="text-[11.5px] text-muted-foreground">
                        {`${formatDateMx(sale.soldAt)} · ${formatTimeMx(sale.soldAt)}`}
                    </div>
                    <Button className="w-full" onClick={onClose}>
                        Listo
                    </Button>
                </div>
            )}
        </Modal>
    );
}
